<template>
  <search-result-section
    :title="$t('SEARCH.SECTION.TICKETS')"
    :empty="!tickets.length"
    :query="query"
    :show-title="showTitle || isFetching"
    :is-fetching="isFetching"
  >
    <ul class="search-list">
      <li v-for="ticket in tickets" :key="ticket.id">
        <search-result-ticket-item
          :id="ticket.id"
          :title="ticket.title"
          :contact-name="ticket.contact && ticket.contact.name"
          :account-id="accountId"
          :created-at="ticket.created_at"
        />
      </li>
    </ul>
  </search-result-section>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchResultSection from './SearchResultSection.vue';
import SearchResultTicketItem from './SearchResultTicketItem.vue';

export default {
  components: {
    SearchResultSection,
    SearchResultTicketItem,
  },
  props: {
    tickets: {
      type: Array,
      default: () => [],
    },
    query: {
      type: String,
      default: '',
    },
    isFetching: {
      type: Boolean,
      default: false,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
  },
};
</script>
